var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgEngagementHeaderIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.466.55c.034.273.152.564.208.841.065.326.09.646.116.978.048.615.167 1.246.244 1.858.17 1.34.24 2.653.55 3.96.088.368.17.709.163 1.102-.244.015-.498.091-.749.11-.497.036-.5-.334-.62-.733-.169-.569-.42-1.117-.59-1.687-.19-.633-.245-1.27-.404-1.906a6.053 6.053 0 0 1-.201-1.536c.005-.527.188-1.049.191-1.567",
    fill: "#FF0082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.816 2.56c-.112.16-.38.327-.554.29-.025-.084.188-.51.205-.594a6.88 6.88 0 0 0 .076-.533c.019-.175.017-.351.06-.522.228.06.273.458.3.635M4.028 22.012s-.189.169-.246.38c-.06.209-.117.42.142.458.259.039.506.227.674.432.167.205.55.26.959.261.33.001.332-.216.297-.32-.036-.104-.398-.364-.662-.552-.263-.187-.616-.671-.616-.671l-.548.012ZM1.721 23.74l-.159.39a.646.646 0 0 0-.03.407c.055.22.148.552.234.693.135.22.652.25.844.174.19-.078.094-.518-.03-.982-.057-.214-.263-.695-.263-.695l-.596.013Z",
    fill: "#FF0082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.727 23.832c-.443-1.52-.299-5.28-.162-8.193l1.728-.205c-.199 2.737-.548 6.234-1.011 8.435 0 0-.316.206-.555-.037Z",
    fill: "url(#engagement-header-icon_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.149 22.203c-.068-.014-.129-.063-.13-.125-.07-3.053-.263-5.088-.435-7.176l1.718-.319c.273 1.845-.179 5.193-.69 7.463-.024.103-.125.18-.246.18-.058 0-.129-.006-.217-.023Z",
    fill: "url(#engagement-header-icon_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.709 21.84c.314.111 1.199.127 1.243-.028.807-2.797.364-11.959.364-11.959l-2.472.988s.316 1.779.543 2.471c.067.206.245 5.92.322 8.528Z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 23.424c.498-1.775 1.545-12.59 1.545-12.59l-3.423.42s.752 10.15.692 12.252c.236.077.894.02 1.186-.082Z",
    fill: "#2E2E2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.152 5.769c.339.231 2.095 1.247 2.21 1.287.543.185 2.283.755 2.8.61.616-.174-.245.994-.243 1.09.002.074-1.87-.36-2.73-.562-.3-.07-2.092-.671-2.069-.957.016-.219-.16-1.6.032-1.468Z",
    fill: "url(#engagement-header-icon_svg__c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.224 7.3c.203-1.352.252-2.418-1.454-3.975-.264-.241-2.36.217-2.434.278l-.094.037c-1.048.414.635 2.31.747 3.22-.271 3.115-1.87 3.665-1.203 5.387.206.53-.266-.716.754-1.09.67-.244 3.314 2.064 4.034 1.324.506-.518-.666-3.074-.35-5.181Z",
    fill: "#00AF9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m2.542 1.97-.255 1.285-.281.104c-.13.048-.157.197-.051.277.447.339 1.577 1.431 2.16 1.049.394-.257-.504-.65-.215-1.918l-.536-.092.009-.723-.83.018Z",
    fill: "url(#engagement-header-icon_svg__d)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.865.927s-.069.91-.173 1.337c-.105.426-.226.84-.754.802C3.41 3.028 2.9 2.705 2.573 1.94c-.33-.767-.117-1.347.26-1.6.378-.251 1.974-.086 2.032.588Z",
    fill: "url(#engagement-header-icon_svg__e)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.928 1.888s.022-.37-.258-.394c-.28-.025-.246.406.046.62.291.215.212-.226.212-.226Z",
    fill: "url(#engagement-header-icon_svg__f)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.455 9.483a.364.364 0 0 0 .108-.122l1.776-3.27-.141-.124-3.124 2.236a.47.47 0 0 0-.154.183l-1.332 2.562a.251.251 0 0 0 .033.28l.072.086a.203.203 0 0 0 .199-.02l2.563-1.811Z",
    fill: "#2E2E2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82 8.892s.295-.141.586-.403c.29-.261.476-.829.424-1.014-.053-.186-.532-.496-.606-.064-.074.43-.15 1.01-.405 1.48Z",
    fill: "url(#engagement-header-icon_svg__g)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M.126 7.69c0 .528.044 1.159.371 1.594.369.49.798.734 1.41.813.85.109 1.663-.195 2.442-.45.685-.224 1.051.017 1.686.085.097.01.195.048.282.068.104-.411-.47-.835-.876-.956-.466-.138-.899.04-1.31.154-.779.215-1.767.26-2.53-.057-.196-.08.103-.19-.027-.372-.12-.167-.157-.74-.111-.91",
    fill: "url(#engagement-header-icon_svg__h)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.439 8.58c-.277-.098-.59-.298-.907-.37a31.45 31.45 0 0 0-.453-.096c-.182-.038.004-.597.022-.733.136-1.024.46-1.893.6-2.918.049-.344.212-.841.733-.541.605.348.98 1.327 1.062 1.922.125.896-.29 2.212-1.006 2.802a.333.333 0 0 1-.08-.112",
    fill: "url(#engagement-header-icon_svg__i)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.555.027c.396-.117 1.03.159 1.311.642.285.49.153 1.365-.05 1.891-.168-.407-.02-1.024-.35-1.472C4.204.735 3.167.48 3.414.091a.63.63 0 0 1 .14-.064Z",
    fill: "#FF0082"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.863.56c-.088.346-.809 1.08-1.009 1.41-.48.79.526 4.42.488 6.053-.012.499.092 1.078-.066 1.555-.263.058-.962.097-1.23.128-.248.03-.399-.06-.611-.07-.044-.011-.082-.044-.124-.056-.058-.228.021-.505.027-.738.009-.356-.02-.5-.082-.922A13.531 13.531 0 0 0 .95 6.469C.697 5.49.868 4.136.883 3.509c.009-.33.198-.743.305-1.36.08-.46.251-.839.54-1.227.346-.465.96-.873 1.437-.86.409.01.517.131.726.437",
    fill: "#FF0082"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.848 11.432c0-.033.003-.065.006-.098-.497.421-1.298.904-1.913 1.17-.386.166-.729.093-1.12.185-.577.138-1.462.426-1.313.857.159.459 1.019.203 1.275.19-.018.079-.486.413-.108.332.413-.09.42-.157.546-.204.723-.272 3.569-1.24 3.293-2.159",
    fill: "url(#engagement-header-icon_svg__j)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.297 6.665s-1.439-.055-1.824 1.933c-.023.116-.024.238-.042.355-.053.35-.857 1.546-1.155 1.889-.195.223-1.239.835-1.327 1.085-.115.323.49.659.605.9.586.108 1.414-.744 1.843-1.102.26-.218.49-.429.61-.724.16-.39.283-.636.13-.904l1.16-3.432Z",
    fill: "#00AF9B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.863 25.536s.204.173.267.388c.063.215.127.431-.153.47-.281.04-.548.233-.729.443-.18.21-.595.266-1.037.266-.358.001-.36-.222-.322-.328.039-.106.43-.372.715-.565.285-.192.666-.688.666-.688l.593.014ZM34.088 27.304l.173.4a.641.641 0 0 1 .033.417c-.059.226-.158.566-.251.71-.147.227-.705.256-.912.177-.207-.08-.103-.53.03-1.006.061-.22.283-.712.283-.712l.644.014Z",
    fill: "#2E2E2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m34.082 27.399.11-.894-.793-.018.083.948s.342.212.6-.036Z",
    fill: "url(#engagement-header-icon_svg__k)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m31.861 25.704.13-1.13-.905.052.177 1.065s.108.136.598.013Z",
    fill: "url(#engagement-header-icon_svg__l)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.228 14.31s-.154 7.45.818 10.645c0 0 .295.202 1.02-.087 0 0 .667-6.242.91-6.951.244-.71.208-2.85.208-2.85l-2.956-.756Z",
    fill: "#2E2E2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.282 15.511s-.27 6.749-.259 7.36c.012.61-.717 3.761-.717 3.761s-.463.256-.946-.02c0 0-.618-4.995-.724-6.024-.106-1.03-.682-5.579-.682-5.579l3.328.502Z",
    fill: "#2E2E2E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.419 7.034c-.23-.16-.97-.548-1.346-.612-.454-.077-1.066.116-1.482.156-.393.281-.893 1.006-.835 2.87.072 2.316-.403 4.819-.457 6.305.418.08 1.851.564 2.294.13.125-1.747-.001-5.145.3-6.763.246-1.318 1.143-1.822 1.526-2.086Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.757 9.449c-.058-1.865.44-2.59.834-2.87-.72.069-1.149 1.099-1.289 1.624-.222.83-.418 8.317-.418 8.317l.271.05c.27.05.523-.139.532-.396.055-1.657.134-4.637.07-6.725Z",
    fill: "#00AF9B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m33.355 4.79.367 1.942c.026.141-.06.279-.209.336-.277.109-.746.227-1.205.05-.17-.066-.272-.22-.25-.38l.178-1.247 1.12-.702Z",
    fill: "url(#engagement-header-icon_svg__m)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.894 9.09c.246-1.327 1.142-1.79 1.526-2.056.257.087.47.258.648.475.258.316.44.73.563 1.135.435 1.027.863 2.507.21 3.373-.076 1.854-.312 4.154-.742 5.297 0 0-.39.096-.501-.85 0 0-.089 1.106-1.133.817a19.601 19.601 0 0 0-.944-.227.448.448 0 0 1-.363-.464c.141-1.957.455-5.98.736-7.5Z",
    fill: "#00AF9B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.268 3.768s-.222.349-.248.956c-.026.607.345 1.426.448 1.595.105.17.597-.01.985-.119.39-.107.625-.256.782-.579.158-.32.34-1.04.334-1.403-.005-.362-.408-1.057-2.301-.45Z",
    fill: "url(#engagement-header-icon_svg__n)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.098 2.719c-.416-.087-.97.295-1.318.158-.347-.136-.445-.244-.702-.19-.423.089-.136.43-.023.5.113.067-.693-.139-.83.288-.137.426.164.782 1.273.72 1.109-.062 1.259-.401 1.637-.197.378.204.326.781.21 1.08-.116.3.303.32.463.07.16-.252.7-2.135-.71-2.43Z",
    fill: "#FF0082"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.773 12.732c.373-.098 1.857-1.126 2.427-1.528a.525.525 0 0 1 .575-.017c.167.11.336.3.358.621.015.222-.137.426-.374.505l-2.404.795s-.511 1.051-1.346 1.176c-.833.125-.909-.664-.967-.935-.057-.27 1.267-.496 1.731-.617Z",
    fill: "url(#engagement-header-icon_svg__o)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.243 10.344c-.746-.524-.909-1.519-.744-2.35.07-.353.236-.752.61-.925.247-.114 1.144-.01.95.398l-.008.012c-.082.003-.27.047-.328.08-.359.208-.613.57-.654 1.063-.026.31-.035.64.023.934.055.28.189.536.172.829 0 0-.005.031-.022-.015M30.195 10.248c-.045-.134-.014-1.002.004-1.21.03-.343.099-.651.187-.952.12-.405.532-1.187.982-1.446.024-.014.004-.018.004-.018-.72-.306-1.27.734-1.421 1.16-.272.769-.143 1.93.207 2.466.005.008.04.035.037 0ZM31.592 12.905l-.32-.97c-.01-.032-.044-.053-.08-.05l-1.323.096c-.05.003-.082.047-.068.088l.49 1.375c.125.03 1.15-.325 1.3-.539Z",
    fill: "#2E2E2E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.006 30.245c-.068-.037-8.843-4.481-8.94-4.477-.017 0-.024.003-.024.003-.045.008-.064.024-.348.168v.001h-.001c-.052.026-.084.082-.084.162l-.008 2.426c-.001.16.127.355.287.435l6.81 3.437.489 1.198.271-.815 1.22.617c.082.04.155.044.208.016l-.003.001c.324-.165.389-.167.389-.317l.008-2.426c.001-.157-.122-.346-.274-.429Zm-.038.516a.547.547 0 0 0-.117-.235c.068.082.103.087.117.235Zm-9.261-4.826h-.002.002Zm.05-.011h-.002.001Zm-.013 0h-.003.003Zm-.011.002-.005.001h.005Zm-.013.004-.004.001a.016.016 0 0 1 .004-.001Zm.165.022.013.006c-.004-.003-.008-.004-.013-.006Zm9.008 7.46.005-.004a.017.017 0 0 1-.005.003Zm.01-.007.005-.004-.005.004Zm.008-.007c.003-.001.004-.003.006-.005l-.006.005Zm.038-.05Zm-.006.01-.003.005a.012.012 0 0 0 .003-.005Zm-.005.01a.026.026 0 0 0-.004.005l.004-.006Zm-.006.008-.006.007.006-.007Zm-.007.01-.006.005.006-.006Zm.043-.366.008-2.154c.01.27-.002.838-.008 2.154Z",
    fill: "#00AF9B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.596 26.959c0-.085.068-.12.152-.075l6.975 3.462a.294.294 0 0 1 .152.234v.168c0 .085-.069.118-.153.074l-6.975-3.463c-.084-.044-.152-.148-.152-.233v-.168ZM21.596 27.936c0-.085.068-.118.152-.074l6.975 3.463c.084.044.152.148.152.233v.168c0 .085-.069.118-.153.075l-6.975-3.463c-.084-.044-.152-.148-.152-.233v-.169Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.683 13.443c-.068-.037-8.843-4.481-8.94-4.477-.016 0-.025.003-.025.003-.044.008-.064.024-.347.168v.001c-.053.026-.085.082-.085.162l-.009 2.425c0 .16.129.355.287.436l6.812 3.437.488 1.197.271-.814 1.22.615c.081.041.155.045.207.017h-.002c.324-.164.388-.166.389-.316l.008-2.426c.001-.156-.123-.345-.274-.428Zm-.038.516a.55.55 0 0 0-.117-.235c.068.082.102.087.117.235Zm-9.261-4.827h-.002.002Zm.05-.01h-.001Zm-.013.001h-.003.003Zm-.011.002h-.005.005Zm-.012.003h-.004.004Zm.164.022.012.006-.012-.006Zm-.012-.006c.001 0 .001 0 0 0 .001 0 .001 0 0 0Zm9.02 7.466Zm.01-.007.005-.004a.027.027 0 0 0-.005.004Zm.007-.007.007-.005a.014.014 0 0 1-.007.005Zm.039-.05-.001.002v-.002Zm-.005.01-.003.005c0-.002.002-.004.003-.005Zm-.006.01-.005.006.005-.007Zm-.006.008-.006.007.005-.007Zm-.008.01-.005.005.006-.006Zm.044-.366.008-2.155c.011.27-.002.84-.008 2.155ZM29.238 21.412c-.068-.038-8.842-4.482-8.94-4.477-.015 0-.024.002-.024.002-.044.008-.064.025-.347.169h-.002c-.051.027-.084.083-.084.162l-.008 2.426c0 .16.128.355.286.435l6.811 3.437.489 1.198.27-.815 1.221.616c.081.041.155.044.207.017l-.002.001c.324-.165.388-.167.389-.317l.008-2.426c.002-.157-.121-.345-.274-.428Zm-.036.515a.554.554 0 0 0-.118-.235c.068.082.102.087.118.235ZM19.939 17.1l-.001.001h.001Zm.05-.01h-.001.001Zm-.011 0-.004.002.004-.001Zm-.012.003h-.005.005Zm-.013.003-.003.001.003-.001Zm.166.022Zm9.007 7.46c.001-.002.003-.002.005-.003-.002 0-.004.002-.005.003Zm.01-.006a.031.031 0 0 1 .005-.005l-.006.005Zm.008-.007a.035.035 0 0 0 .005-.006l-.005.006Zm.037-.051v.001-.001Zm-.004.01-.003.005.003-.005Zm-.006.01-.005.006.005-.006Zm-.007.009a.044.044 0 0 1-.005.006l.005-.006Zm-.007.009-.005.006a.037.037 0 0 0 .005-.006Zm.044-.366.007-2.154c.012.27-.002.839-.007 2.154Z",
    fill: "#00AF9B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.514 10.486c0-.085.067-.117.153-.074l6.974 3.463c.085.044.153.149.152.234v.168c0 .085-.069.117-.153.074l-6.975-3.463c-.084-.044-.152-.149-.152-.233v-.168ZM20.514 11.464c0-.085.067-.117.153-.074l6.974 3.463c.085.044.153.149.152.233v.168c0 .085-.069.119-.153.074l-6.975-3.462c-.084-.044-.152-.148-.152-.233v-.169ZM21.009 18.455c0-.085.069-.118.153-.074l6.976 3.462c.083.044.151.149.151.233v.168c0 .085-.07.118-.153.074l-6.976-3.462c-.084-.044-.152-.148-.151-.233v-.168ZM21.009 19.433c0-.085.069-.118.153-.074l3.75 1.876c.084.044.152.148.152.233v.168c0 .085-.069.117-.153.074l-3.75-1.876c-.084-.044-.152-.149-.151-.233v-.168h-.001Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m16.082 12.646.009 2.434c0 .15.064.217.388.705a.547.547 0 0 0 .205.188l1.22.604.272 1.086.489-.71 6.81 3.372c.16.079.288.012.288-.149l-.009-2.434a.457.457 0 0 0-.084-.246v-.001l-.001-.002c-.283-.426-.303-.463-.347-.515l-.024-.026c-.097-.102-8.872-4.43-8.94-4.46-.152-.07-.276-.004-.276.153Zm.43.281a.148.148 0 0 0-.117.117c.015-.133.05-.103.117-.117Zm9.146 4.552-.002-.003.002.003Zm-.05-.062-.002-.002.002.002Zm.014.016-.003-.003.003.003Zm.012.015c-.001-.002-.003-.003-.003-.005 0 .002.002.003.003.005Zm.012.015a.016.016 0 0 1-.004-.005l.004.005Zm-.181-.155a.29.29 0 0 1 0 0Zm-9-1.545.005.007-.005-.007Zm-.01-.018.006.01-.006-.01Zm-.008-.017.005.011-.006-.01Zm-.032-.075v-.001.001Zm.007.02-.003-.007c0 .003.003.005.003.008Zm.007.02-.004-.011.004.01Zm.007.016-.005-.013a.079.079 0 0 1 .005.013Zm.008.015Zm-.057-2.582.008 2.162c-.006-1.322-.019-1.903-.008-2.162Z",
    fill: "#FF0082"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.047 14.935c0 .085.069.187.153.227l6.975 3.51c.084.04.152.004.152-.08v-.169c0-.085-.068-.186-.153-.227l-6.975-3.51c-.084-.04-.152-.004-.152.08v.169ZM17.047 13.957c0 .085.069.187.153.227l6.975 3.51c.084.04.152.004.152-.08v-.169c0-.085-.068-.186-.153-.227l-6.975-3.51c-.084-.041-.152-.004-.152.08v.169Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m15.858 19.55.008 2.435c.001.15.066.217.389.705-.002-.001-.002-.002-.002-.004.052.081.125.152.207.192l1.22.604.27 1.085.49-.71 6.81 3.372c.16.079.288.012.288-.148l-.009-2.435a.458.458 0 0 0-.084-.246l-.001-.002c-.283-.427-.303-.463-.348-.515l-.024-.027c-.098-.102-8.872-4.43-8.94-4.46-.15-.069-.274-.004-.274.154Zm.43.282a.15.15 0 0 0-.117.116c.015-.131.049-.103.118-.116Zm9.146 4.55-.002-.001.002.002Zm-.05-.06-.002-.002.002.002Zm.014.015-.003-.003.003.003Zm.013.016-.005-.006.005.006Zm.012.015-.004-.005.004.005Zm-.183-.155.014.007-.014-.007Zm-9-1.546.006.008-.005-.008Zm-.01-.018.006.01-.005-.01Zm-.008-.016.006.01-.006-.01Zm-.031-.076-.001-.002v.002Zm.008.021Zm.006.018-.005-.01a.036.036 0 0 1 .005.01Zm.008.017-.006-.012.006.012Zm.008.016-.007-.013.007.013Zm-.058-2.582.008 2.161c-.006-1.321-.02-1.903-.008-2.161Z",
    fill: "#FF0082"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.943 21.96c0 .084.069.186.153.227l6.975 3.51c.084.04.153.004.152-.082v-.168c0-.085-.069-.187-.153-.227l-6.975-3.51c-.085-.04-.153-.004-.153.08l.001.17ZM16.943 20.982c0 .085.069.187.153.227l5.116 2.579c.085.04.153.004.152-.082v-.168c0-.085-.069-.186-.153-.227l-5.116-2.578c-.085-.04-.153-.004-.153.08l.001.17Z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.144 39.226s-.11.323-.143.442c-.02.074.02.272.056.415.023.095.107.17.215.193a.795.795 0 0 0 .564-.09l1.512-.894c.08-.047.106-.14.06-.215l-.04-.067a.313.313 0 0 0-.335-.13c-.342.076-.977.203-1.202.152-.314-.071-.687.194-.687.194Z",
    fill: "#2E2E2E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.097 38.267s.004.947.045 1.08c.042.132.533.127.665-.157.112-.242.173-1.028.173-1.028l-.883.105Z",
    fill: "url(#engagement-header-icon_svg__p)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.063 39.756s-.152.31-.2.425c-.03.071-.015.273.002.418.01.097.083.18.188.214.188.06.395.048.573-.032l1.619-.736c.085-.039.124-.128.089-.207l-.032-.07c-.05-.113-.18-.18-.316-.165-.349.04-.997.103-1.214.03-.303-.102-.709.123-.709.123Z",
    fill: "#2E2E2E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.013 38.872s-.085.944-.056 1.08c.03.135.52.166.677-.11.135-.232.27-1.012.27-1.012l-.891.042Z",
    fill: "url(#engagement-header-icon_svg__q)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.552 28.79s.514 3.716.337 4.698c-.337 1.86.079 4.78.079 4.78.38.206.778.205 1.09 0 0 0 .493-6.204 1.373-7.52V28.66l-1.172-1.122-1.263-.195c-.385.148-.515 1.084-.444 1.447Z",
    fill: "#00AF9B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 28.359s-.201 2.534-.621 5.084c-.396 2.399-1.008 4.797-1.096 5.501a.347.347 0 0 1-.178.258.922.922 0 0 1-.647.1.247.247 0 0 1-.208-.207c-.092-.783-.14-4.35-.137-4.995.003-.727-.71-5.015-.71-5.015l.233-1.742 3.364 1.016Z",
    fill: "#00AF9B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m12.144 16.46-.156 1.332c-.012.103-.104.186-.22.203a1.758 1.758 0 0 1-1.182-.23.393.393 0 0 1-.187-.446l.281-.981 1.464.123Z",
    fill: "url(#engagement-header-icon_svg__r)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12.919 14.294s.293 1.676.1 2.12c-.191.443-1.394.646-1.702.514-.309-.131-1.218-1.045-1.266-1.448-.28-2.335 1.374-2.38 2.868-1.186Z",
    fill: "url(#engagement-header-icon_svg__s)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.31 23.75c.79-.518 1.836.04 1.842.9.001.082-.086.152-.174.126a.142.142 0 0 1-.046-.024c-.121-.096-.29-.421-.566-.47-.327-.059-.512.038-.906-.134l-.15-.398Z",
    fill: "url(#engagement-header-icon_svg__t)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M15.026 21.2c.408-.484 1.105-.946 1.556-1.528.415-.538.686-1.115.977-1.673.287-.044.896-.181.996-.464.107-.3-.253-.575-.161-.866.065-.205.391-.212.319-.487-1.04.293-1.697 1.08-2.321 1.87-.185.234-.387.48-.609.708-.436.447-.751.978-.884 1.555-.088.379-.095.74.127.884Z",
    fill: "url(#engagement-header-icon_svg__u)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16.468 17.544c.079-.082.269-.233.366-.24.038-.002.044.018.055.142.024.267.472.774.473 1.058.002.957-1.509 2.684-2.612 3.072-.978.344-3.32-.796-3.768-1.07-.447-.274-.901-1.2.092-1.528.993-.328 2.917.928 3.205.914.62-.03 1.637-1.782 2.189-2.348Z",
    fill: "#2E2E2E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.189 17.988c.315.943 1.23 1.061 1.737 2.595.298.902.392 2.465-.223 4.097-.317.843 1.36 2.869 1.367 3.305.002.08-.258.834-1.021 1.084-.764.251-4.832.077-4.832-1.188 0-1.022.641-1.987.552-2.553-.397-2.504-.221-7.017.494-7.56.191-.145.021-.74.358-.659.962.231.77.07 1.556.033.242-.011-.032.714.012.846Z",
    fill: "#2E2E2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16.028 23.502s.581-.05.73.437c.146.488 0 .649 0 .649s-3.221.556-4.15-.093c-.825-.576-2.17-4.251-2.12-4.728.052-.476.748-1.279 1.563-.684.815.595.759 3.287 1.542 4.03.42.399 2.435.389 2.435.389Z",
    fill: "#2E2E2E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.89 18.987c-.726-.058-1.23.649-1.463 1.223-.374.925-.339 1.769-.177 2.73.071.424.157.925.344 1.154.45.551 1.47-.225 1.575-.088.106.14.215.21.072.277-.362.17-1.498.685-1.961.013-.293-.425-.338-.671-.462-1.165-.243-.969-.187-2.167.114-3.124.177-.563.972-1.76 1.823-1.22.09.056.17.088.135.2Z",
    fill: "#FF0082"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.017 20.448c-.648.008-1.347-.244-1.915.036-.694.343-.666 1.352-.57 2.021.107.74.213 2.133 1.455 1.9.545-.103 1.036-.417 1.105-.911.11-.794-.004-1.603-.06-2.394-.026-.362.114-.677-.329-.81-.222-.066-.65-.026-.852.063a1.126 1.126 0 0 0-.568.06c-.469.195-.503.67-.245 1.057",
    fill: "#FF0082"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.76 13.904c.146.581-.231.847-.55 1.32-.287.424-.419.828-.423 1.343-.006.626.469 1.218.37 1.85-.045.285-.197.34-.442.411-.27.077-.5.213-.663.429-.306.405-.434.704-1.052.75-.63.047-1.34-.384-1.396-.958-.018-.174.122-.344.073-.515-.054-.19-.293-.333-.443-.465-.436-.38-1.073-1.155-.693-1.703.137-.198.376-.324.535-.508.174-.2.25-.4.3-.648.105-.531.076-1.057.605-1.413.191-.128.353-.203.503-.365a1.73 1.73 0 0 1 .588-.412c.384-.17.924-.246 1.346-.225.564.027 1.281.257 1.675.617.384.352.378.842.043.891-.118.017-.3-.064-.334.045-.078.24-.23.389-.49.583",
    fill: "url(#engagement-header-icon_svg__v)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__a",
    x1: -3.27,
    y1: 17.92,
    x2: 5.165,
    y2: 21.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F6AC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__b",
    x1: 8.983,
    y1: 14.564,
    x2: 4.849,
    y2: 18.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F6AC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__c",
    x1: 8.024,
    y1: 3.137,
    x2: 5.859,
    y2: 11.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F6AC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__d",
    x1: 2.546,
    y1: 6.901,
    x2: 3.122,
    y2: 2.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F6AC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__e",
    x1: 7.066,
    y1: 1.202,
    x2: 0.307,
    y2: 2.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F6AC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__f",
    x1: 4.155,
    y1: 1.227,
    x2: 2.125,
    y2: 2.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6AC53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__g",
    x1: 9.852,
    y1: 8.025,
    x2: 8.794,
    y2: 8.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F6AC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__h",
    x1: 0.126,
    y1: 8.889,
    x2: 6.329,
    y2: 8.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F6AC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__i",
    x1: -0.049,
    y1: 6.269,
    x2: 2.521,
    y2: 6.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__j",
    x1: 28.505,
    y1: 12.759,
    x2: 23.515,
    y2: 12.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__k",
    x1: 33.384,
    y1: 26.998,
    x2: 34.176,
    y2: 27.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__l",
    x1: 31.974,
    y1: 25.169,
    x2: 31.071,
    y2: 25.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__m",
    x1: 32.719,
    y1: 0.966,
    x2: 32.829,
    y2: 5.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__n",
    x1: 30.754,
    y1: 6.328,
    x2: 33.532,
    y2: 2.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__o",
    x1: 28.881,
    y1: 9.664,
    x2: 34.256,
    y2: 15.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__p",
    x1: 10.097,
    y1: 38.796,
    x2: 10.98,
    y2: 38.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#FAD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#F8BE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F6A154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__q",
    x1: 11.963,
    y1: 39.399,
    x2: 12.842,
    y2: 39.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#FAD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#F8BE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F6A154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__r",
    x1: 9.705,
    y1: 14.634,
    x2: 13.691,
    y2: 22.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#FAD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#F8BE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F6A154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__s",
    x1: 10.096,
    y1: 19.745,
    x2: 12.359,
    y2: 10.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#FAD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#F8BE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F6A154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__t",
    x1: 16.31,
    y1: 24.166,
    x2: 18.152,
    y2: 24.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#FAD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#F8BE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F6A154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__u",
    x1: 14.741,
    y1: 18.868,
    x2: 18.939,
    y2: 18.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#FAD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#F8BE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F6A154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engagement-header-icon_svg__v",
    x1: 7.451,
    y1: 16.281,
    x2: 13.261,
    y2: 16.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })))));
};
export { SvgEngagementHeaderIcon as ReactComponent };
export default __webpack_public_path__ + "161346202cf441355a033e6d392cfe1a.svg";